import React from 'react';

class Errors extends React.Component {
  render () {
    const { errors } = this.props

    if ( errors === undefined || errors.length === 0 ) {
      return ''
    }

    return (
      <div className="row errorsContainer z-depth-2">
        <ul>
          {
            errors.map( (error, index) => {
              return (
                <li key={index}>{error}</li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}

export default Errors



// WEBPACK FOOTER //
// ./src/js/components/Errors.js